<template>
  <div>
    <!-- <h2>Подтвердите, что вы человек</h2> -->
    <div class="title-text">{{title}}</div>
    
    <!-- Кликаем по контейнеру wrapper -->
    <div class="wrapper" id="captcha-wrapper">
      <div class="captcha-img-wrapper">
        <img id="captcha-img" :src="captchaImg" alt="Загрузка капчи...">
      </div>
      <div>
        <input :disabled="disabled" class="user-anwser" v-model="userAnwser" />
      </div>
    </div>

    <div class="controls">
      <button class="btn-renew" id="renew-btn" title="Обновить капчу" @click="renewCaptchaClick">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38l5.67-5.67"/>
        </svg>
      </button>
      <button
        class="btn-submit"
        id="submit-btn"
        :disabled="disabled || !userAnwser.length"
        @click="submit">Проверить</button>
    </div>

    <div id="status-message"></div>
  </div>
</template>

<script>
export default {
  name: 'ClickableCaptcha',
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    captchaId: {
      type: String,
      default: ''
    },
    captchaImageBase64: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      userAnwser: ''
    }
  },
  computed: {
    captchaImg() {
      return this.captchaImageBase64.startsWith("data:image")
        ? this.captchaImageBase64
        : `data:image/png;base64,${this.captchaImageBase64}`;
    }
  },
  methods: {
    renewCaptchaClick() {
      this.userAnwser = '';
      this.$emit('renew');
    },
    submit() {
      const payload = {
        captchaId: this.captchaId,
        value: this.userAnwser
      };
      this.$emit('input', payload);
    }
  }
}
</script>

<style scoped>
.captcha-container {
  background: #ffffff;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  width: 520px;
  text-align: center;
}
.title-text {
  margin-top: 0;
  /* color: #333333; */
  font-size: 20px;
  margin-bottom: 20px;
}
.wrapper {
  position: relative;
  display: inline-block;
}
.captcha-img-wrapper {
  background: #eee;
  border-radius: 6px;
  overflow: hidden;
  border: 2px solid #e0e0e0;
}
.user-anwser {
  margin-top: 1rem;
  width: stretch;
  /* width: 100%; */
  /* box-sizing: border-box; */
}
/* Картинка пропускает клики сквозь себя прямо на контейнер .wrapper */
#captcha-img {
  display: block;
  max-width: 100%;
  height: auto;
  user-select: none;
  -webkit-user-drag: none;
  pointer-events: none; 
}
.controls {
  margin-top: 15px;
  display: flex;
  justify-content: normal;
  gap: 10px;
  align-items: center;
}
button {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  transition: background 0.2s;
}
.btn-submit {
  background-color: #007bff;
  color: white;
}
.btn-submit:hover {
  background-color: #0056b3;
}
.btn-renew {
  background-color: #6c757d;
  color: white;
  padding: 10px 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-renew:hover {
  background-color: #5a6268;
}
</style>